import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { ProductModifier } from "~/providers/product-provider";

interface ProductStoreState {
  productModifierFormOpen: boolean;
  selectedProductModifier?: ProductModifier;
  setSelectedProductModifier: (selected?: ProductModifier) => void;
  setProductModifierFormOpen: (open: boolean) => void;
}

export const useProductModifierStore = create<ProductStoreState>()(
  devtools((set) => ({
    productModifierFormOpen: false,
    setSelectedProductModifier(selected) {
      set(() => ({ selectedProductModifier: selected }));
    },
    setProductModifierFormOpen(open) {
      set(() => ({ productModifierFormOpen: open }));
    },
  })),
);
